// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ooxXH","select":"styles_select__3KJ5E"};